import { useEffect, useMemo, useRef, useState } from "react";

import ReactSwal from "react-sweetalert2";
import { Cropper } from "react-cropper";

const ImageSelector = ({onChange = (_data) => {}, open = false, setOpen, image, setImage, previewImage, setPreviewImage, cropperWidth = 200, cropperHeight = 200}) => {
    const [swalProps, setSwalProps] = useState({
        show: false,
    });

    const uniqueId = (prefix = 'image-selector-') => prefix + Math.random().toString(16).slice(-4);
    const id = useMemo(() => uniqueId(), []);

    useEffect(() => {
        setSwalProps({
            ...swalProps,
            show: open,
        })
    }, [open])

    const cropperRef = useRef(null);

    return (
        <>
            <ReactSwal
                {...swalProps}
                showConfirmButton
                showCancelButton
                confirmButtonText="Cortar imagen"
                cancelButtonText="Dejar imagen por defecto"
                confirmButtonColor="#43BFED"
                customClass={{
                    confirmButton: 'bg-primary text-white rounded py-2 px-4 mx-2',
                    cancelButton: 'bg-gray-400 text-white rounded py-2 px-4 mx-2'
                }}
                onConfirm={() => {
                    const imageElement = cropperRef?.current;
                    const cropper = imageElement?.cropper;
                    setPreviewImage(
                        cropper.getCroppedCanvas().toDataURL()
                    );
                    cropper.getCroppedCanvas().toBlob((blob) => {
                        setImage(blob);
                        onChange && onChange({ image: blob, previewImage: cropper.getCroppedCanvas().toDataURL() });
                    });
                    setOpen(false);
                }}
                didClose={() => {
                    setOpen(false);
                }}
                onError={() => {
                    setOpen(false);
                }}
                onResolve={() => {
                    setOpen(false);
                }}
            >
                <Cropper
                    style={{ height: 400, width: "100%" }}
                    preview={`#${id}`}
                    src={previewImage}
                    zoomOnWheel
                    cropBoxMovable
                    aspectRatio={cropperWidth / cropperHeight}
                    background={false}
                    responsive={true}
                    // minCropBoxWidth={200}
                    // minCropBoxHeight={200}
                    movable
                    scalable
                    checkOrientation={false}
                    ref={cropperRef}
                    guides={true}
                />
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'between' }}>
                    <div>
                        <h3>
                            Imagen cortada
                        </h3>
                        <div style={{ width: cropperWidth, height: cropperHeight, position: 'relative', overflow: 'hidden', border: '1px solid black' }}>
                            <div id={id} style={{ width: '100%', height: '100%', position: 'absolute', top: '0px', left: '0px' }}></div>
                        </div>
                    </div>
                    <div>
                        <h3>
                            Imagen por defecto
                        </h3>
                        <div style={{ width: cropperWidth, height: cropperHeight, position: 'relative', overflow: 'hidden', border: '1px solid black' }}>
                            <img style={{ width: '100%', height: '100%', position: 'absolute', top: '0px', left: '0px' }} src={previewImage || image} />
                        </div>
                    </div>
                </div>
            </ReactSwal>
        </>
    );
};

export default ImageSelector;
